import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../../components/header-desktop/header-desktop';

@Component({
    imports: [CommonModule, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent],
    selector: 'app-detail',
    standalone: true,
    templateUrl: './detail.page.html'
})
export class DetailPage implements OnInit {
  constructor(
    private metaService: Meta,
    private titleService: Title,
  ) { }

  ngOnInit() {
    this.titleService.setTitle('How the Job Site Works');
    this.metaService.updateTag(
      { name: 'description', property: 'og:description', content: 'Find, hire and recruit job hunters and job seekers, for free. If you are unemployed looking for a job, or in employment wanting to move to your dream job or contract.' }
    )
  }

  ionViewWillLeave() {
    this.titleService.setTitle('How it Works in the Future of Work');
    this.metaService.updateTag(
      { name: 'description', property: 'og:description', content: 'What is the Future of Work marketplace for the "no-exploit" freelancer gig economy, permanent & contract recruitment job site and job board platform, volunteering & business advertisements' }
    )
  }
}
